/** Broadcast elimination replays. Art lives at `art`.jpg / .mp4 / .mp3. */

export interface EliminationScene {
  id: string;
  art: string;
  kicker: string;
  title: string;
  line: string;
  tag: string;
  /** Omit from random pick until jpg/mp4/mp3 exist. Forced preview still works. */
  available?: boolean;
}

export const ELIMINATION_SCENES: readonly EliminationScene[] = [
  {
    id: 'fallen',
    art: '/assets/cinematics/death',
    kicker: 'LIVE FROM THE GRAND ARENA',
    title: 'ELIMINATED',
    line: 'THE CONTESTANT HAS FALLEN',
    tag: 'FINAL MOMENTS',
  },
  {
    id: 'mop',
    art: '/assets/cinematics/death_mop',
    kicker: 'LIVE FROM THE GRAND ARENA',
    title: 'ELIMINATED',
    line: 'THE MOP IS ALREADY EN ROUTE',
    tag: 'CLEANUP CREW',
  },
  {
    id: 'replay',
    art: '/assets/cinematics/death_replay',
    kicker: 'ABN SPORTS DESK',
    title: 'INSTANT REPLAY',
    line: 'ONE LAST SPARK',
    tag: 'SLO-MO',
  },
  {
    id: 'claimed',
    art: '/assets/cinematics/death_claimed',
    kicker: 'LIVE FROM THE GRAND ARENA',
    title: 'CLAIMED',
    line: 'THE PORTAL KEEPS WHAT IT TAKES',
    tag: 'FINAL MOMENTS',
  },
  {
    id: 'cabbages',
    art: '/assets/cinematics/death_cabbages',
    kicker: 'CROWD CAM',
    title: 'ELIMINATED',
    line: 'THE CHEAP SEATS HAVE SPOKEN',
    tag: 'FAN REACTION',
  },
  {
    id: 'hat',
    art: '/assets/cinematics/death_hat',
    kicker: 'LIVE FROM THE GRAND ARENA',
    title: 'ELIMINATED',
    line: 'THE HAT STILL STANDS',
    tag: 'LAST RELIC',
    available: false,
  },
] as const;

export function pickEliminationScene(prefer?: string | null): EliminationScene {
  if (prefer) {
    const id = prefer === '1' || prefer === 'true' || prefer === '' ? '' : prefer;
    if (id) {
      const hit = ELIMINATION_SCENES.find((s) => s.id === id);
      if (hit) return hit;
    }
  }
  const pool = ELIMINATION_SCENES.filter((s) => s.available !== false);
  return pool[Math.floor(Math.random() * pool.length)]!;
}
